// extracted by mini-css-extract-plugin
export default {"address":"style_address__-z-FD","address_title":"style_address_title__YWdxT","address_searchBlock":"style_address_searchBlock__CFZ4U"};